module.exports = __webpack_public_path__ + "img/album21_21.350c70da.jpg";